<div class="row mt-10">
    <div class="col-12 d-flex justify-content-between align-items-center">
        <div class="text-muted">
            <span>{{itemNum$|async}} items - Sorted by {{sortColumn$|async}}</span>
            <span *ngIf="loading$|async" class="ml-2">Loading&hellip;</span>
        </div>

        <div class="d-flex align-items-center" style="gap: 0.5rem;">
            <div style="width: 300px;">
                <mat-form-field class="mat-form-field-fluid">
                    <input matInput [formControl]="searchControl" placeholder="Search this list" />
                </mat-form-field>
            </div>
            <button mat-icon-button type="button" [matTooltip]="'Filter'" (click)="onClickFilter()">
                <mat-icon>filter_list</mat-icon>
            </button>
            <button mat-stroked-button type="button" color="warn" (click)="onClickReset()">
                Reset
            </button>
            <ng-container *ngIf="!readonly">
                <button mat-raised-button type="button" color="primary" [matMenuTriggerFor]="addComparableMenu">
                    Add new comparable
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #addComparableMenu="matMenu">
                    <!--
                        One item unless the caller offers a choice of sub types, which only
                        a Mixed Use target property does -- it has no type of its own that a
                        comparable can have, so its component types are listed instead.
                    -->
                    <button mat-menu-item type="button" *ngIf="addComparableOptions == null"
                            (click)="onClickAddComparable(null)">
                        Add with form
                    </button>
                    <button mat-menu-item type="button"
                            *ngFor="let option of addComparableOptions"
                            (click)="onClickAddComparable(option)">
                        {{ addComparableLabel(option) }}
                    </button>
                </mat-menu>
            </ng-container>
        </div>
    </div>
</div>

<div class="row mt-4">
    <div class="col-12 mat-table-wrapper">
        <mat-table class="comparables-table" [dataSource]="dataSource$"
            matSort
            [matSortActive]="initialSort.active"
            [matSortDirection]="initialSort.direction"
            (matSortChange)="onSortChange($event)"
        >
            <ng-container matColumnDef="index">
                <mat-header-cell *matHeaderCellDef mat-sort-header>#</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.refNum }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="property_sub_type">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Property Sub-Type</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.propertySubTypeName ? item.propertySubTypeName : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="building_name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Building Name / Number</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.buildingName ? item.buildingName : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="street">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Street</mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <span *ngIf="item.street; else noData"
                        [ngbPopover]="item.street"
                        triggers="mouseenter:mouseleave"
                        class="cursor-pointer text-truncate"
                    >{{ item.street }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="community">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Community</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.communityName ? item.communityName : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="bedrooms">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Bedrooms</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.bedrooms != null ? item.bedrooms : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="size">
                <mat-header-cell *matHeaderCellDef mat-sort-header>BUA</mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <ng-container *ngIf="item.size != null; else noData">
                        {{ item.size|mask:'separator.2':{thousandSeparator:','} }} {{ item.sizeAcronym }}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Total Price</mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <ng-container *ngIf="item.price != null; else noData">
                        {{ item.currency }} {{ item.price|mask:'separator.2':{thousandSeparator:','} }}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="price_per_size">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Price on BUA</mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <ng-container *ngIf="item.pricePerSize != null; else noData">
                        {{ item.currency }} {{ item.pricePerSize|mask:'separator.2':{thousandSeparator:','} }}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="transaction_type">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Transaction type</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.transactionType ? item.transactionType : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.sourceDate ? (item.sourceDate|date:(item.transactionType === 'Listing' ? 'MMM yyyy' : 'dd MMM yyyy')) : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="offer">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Offer</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ item.offerType ? item.offerType : 'N/A' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <ng-container *ngIf="selectedRefNums$|async as refNums">
                        <button mat-stroked-button type="button"
                            *ngIf="!readonly"
                            [color]="isSelected(refNums, item) ? 'warn' : 'primary'"
                            (click)="onSelect(item, isSelected(refNums, item))">
                            {{ isSelected(refNums, item) ? 'Remove' : 'Select' }}
                        </button>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <div class="mat-table-message" *ngIf="!(loading$|async) && !(itemNum$|async)">
            {{ 'GENERAL.MESSAGE.NO_DATA' | translate }}
        </div>
        <div class="mat-table-message" *ngIf="loading$|async">
            {{ 'GENERAL.MESSAGE.PLEASE_WAIT' | translate }}
        </div>

        <div class="mat-table-bottom">
            <mat-spinner [diameter]="20" *ngIf="loading$|async"></mat-spinner>
            <mat-paginator
                [length]="itemNum$|async"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex$|async"
                [hidePageSize]="true"
                [showFirstLastButtons]="true"
                (page)="onPageChange($event)">
            </mat-paginator>
        </div>
    </div>
</div>

<ng-template #noData>N/A</ng-template>
